/* eslint-disable */

//// ======================== Animation of Fall ====================================
/// Author: Kiryl Smalousky, Muse_Cafe
/// Build : 1.0 / 05.05.2016


/// init(params); // init the instance
/// exemples with all options,
/// params = {
//     count: 25,
//     adaptive_count: true,

//     speed_x: -40,
//     speed_y: 140,
//     random_y_speed: 30,
//     rotate_speed: 20,
//     random_rotate: 40,

//     use_pendulum: true,
//     amplitude: 60,
//     period: 5,
//     length: 190,
//     random_pendulum: 30,

//     item_images: item_images,
//     z: 0
// };

/// camvas: DOM element

var AnimationOfFall = function (canvas) {

    "use strict";

    var scope = this, scene = undefined;
    this.p = undefined;
    var item_per_width = undefined;

    // init instance with all needed parameters
    this.init = function (p) {

        this.p = p;

        // check inputted params and set default values if param.[PROPERTY] is undefined
        if (p.item_images === undefined) throw ("Animation of Fall Error: 'item_images' init param is missing!");

        this.p.count = (p.count !== undefined && p.count > 0) ? p.count : 25;
        this.p.speed_x = (p.speed_x !== undefined) ? p.speed_x : -40;
        this.p.speed_y = (p.speed_y !== undefined) ? p.speed_y : 140;

        this.p.adaptive_count = (p.adaptive_count !== undefined) ? p.adaptive_count : false;
        this.p.use_pendulum = (p.use_pendulum !== undefined) ? p.use_pendulum : true;
        this.p.rotate_speed = (p.rotate_speed !== undefined) ? p.rotate_speed : 20;

        this.p.amplitude = (p.amplitude !== undefined) ? p.amplitude : 60;
        this.p.period = (p.period !== undefined) ? p.period : 5;
        this.p.length = (p.length !== undefined) ? p.length : 190;
        this.p.random_pendulum = (p.random_pendulum !== undefined) ? p.random_pendulum : 30;
        this.p.random_rotate = (p.random_rotate !== undefined) ? p.random_rotate : 40;
        this.p.random_y_speed = (p.random_y_speed !== undefined) ? p.random_y_speed : 30;

        // calc items count per width
        item_per_width = this.p.count / canvas.clientWidth;

        // init scene
        scene = new Scene();
        add_items();
    };

    // start animation
    this.play = function () {

        if (!scene) throw ("Animation of Fall Error: Call 'init(params)' before play()! ");
        scene.start();

    };

    // stop animation
    this.stop = function () {

        scene.stop_();
    };


    /// -------------  PRIVATE SECTION ----------------

    /// Check visibility of DOM element for saving device performance
    /// needed for not updating scene when DOM canvas is not visible on page
    function is_visible() {

        /**
         * Checks if a DOM element is visible. Takes into
         * consideration its parents and overflow.
         *
         * @param (el)      the DOM element to check if is visible
         *
         * These params are optional that are sent in recursively,
         * you typically won't use these:
         *
         * @param (t)       Top corner position number
         * @param (r)       Right corner position number
         * @param (b)       Bottom corner position number
         * @param (l)       Left corner position number
         * @param (w)       Element width number
         * @param (h)       Element height number
         */
        function _isVisible(el, t, r, b, l, w, h) {

            var p = el.parentNode,
                VISIBLE_PADDING = 2;


            if (!_elementInDocument(el)) {
                return false;
            }

            //-- Return true for document node
            if (9 === p.nodeType) {
                return true;
            }

            //-- Return false if our element is invisible
            if (
                '0' === _getStyle(el, 'opacity') ||
                'none' === _getStyle(el, 'display') ||
                'hidden' === _getStyle(el, 'visibility')
            ) {
                return false;
            }

            if (
                'undefined' === typeof (t) ||
                'undefined' === typeof (r) ||
                'undefined' === typeof (b) ||
                'undefined' === typeof (l) ||
                'undefined' === typeof (w) ||
                'undefined' === typeof (h)
            ) {
                t = el.offsetTop;
                l = el.offsetLeft;
                b = t + el.offsetHeight;
                r = l + el.offsetWidth;
                w = el.offsetWidth;
                h = el.offsetHeight;
            }
            //-- If we have a parent, let's continue:
            if (p) {
                //-- Check if the parent can hide its children.
                if (('hidden' === _getStyle(p, 'overflow') || 'scroll' === _getStyle(p, 'overflow'))) {
                    //-- Only check if the offset is different for the parent
                    if (
                        //-- If the target element is to the right of the parent elm
                        l + VISIBLE_PADDING > p.offsetWidth + p.scrollLeft ||
                        //-- If the target element is to the left of the parent elm
                        l + w - VISIBLE_PADDING < p.scrollLeft ||
                        //-- If the target element is under the parent elm
                        t + VISIBLE_PADDING > p.offsetHeight + p.scrollTop ||
                        //-- If the target element is above the parent elm
                        t + h - VISIBLE_PADDING < p.scrollTop
                    ) {
                        //-- Our target element is out of bounds:
                        return false;
                    }
                }
                //-- Add the offset parent's left/top coords to our element's offset:
                if (el.offsetParent === p) {
                    l += p.offsetLeft;
                    t += p.offsetTop;
                }
                //-- Let's recursively check upwards:
                return _isVisible(p, t, r, b, l, w, h);
            }
            return true;
        }

        //-- Cross browser method to get style properties:
        function _getStyle(el, property) {
            if (window.getComputedStyle) {
                return document.defaultView.getComputedStyle(el, null)[property];
            }
            if (el.currentStyle) {
                return el.currentStyle[property];
            }
        }

        function _elementInDocument(element) {
            while (element = element.parentNode) {
                if (element == document) {
                    return true;
                }
            }
            return false;
        }

        if (this.getBoundingClientRect) {

            var n = this.getBoundingClientRect();
            if (n.bottom < 0 || n.top - window.innerHeight > 0) return false;
        }

        return _isVisible(this);
    };

    // convert dedries to radians
    function inRad(num) { return num * Math.PI / 180; }

    function get_random_image(item_images) {

        var number = Math.floor(Math.random() * (item_images.length));
        return item_images[number];
    };

    // value, dispersion in percent
    function random_interval(val, val_dispersion) {

        val_dispersion /= 100;

        var max = val * (Math.abs(val_dispersion) + 1),
            min = val * (1 - Math.abs(val_dispersion));

        return Math.random() * (max - min) + min;
    };

    // create items based inputted params
    var create_item = function () {

        var x = Math.round(Math.random() * (canvas.width + 1));
        var y = Math.round(Math.random() * (canvas.height + 1));

        // randomize input params
        var start_period = Math.round(Math.random() * 1000);
        var image = get_random_image(scope.p.item_images);


        var amplitude = random_interval(scope.p.amplitude, scope.p.random_pendulum);
        var period = random_interval(scope.p.period, scope.p.random_pendulum);
        var length = random_interval(scope.p.length, scope.p.random_pendulum);

        if (!scope.p.use_pendulum) {

            amplitude = period = length = 0;
        }

        var speed_y = random_interval(scope.p.speed_y, scope.p.random_y_speed);
        var rotate_speed = random_interval(scope.p.rotate_speed, scope.p.random_rotate);
        // randomize rotate direction
        rotate_speed = (Math.random() - 0.5) > 0 ? rotate_speed : -rotate_speed;


        return new Item(x, y, rotate_speed, image, scope.p.speed_x, speed_y,
            start_period, amplitude, period, length, scope.p.z);
    };

    // add items by rules in inputed params
    var add_items = function () {

        for (var i = 0; i < scope.p.count; ++i) {

            var item = create_item();
            if (item)
                scene.objects.push(item);
        }

        // prototype of layaring
        scene.sort_objects_by_z_index();
    };

    // remove all items from scene
    this.delete_items = function () {

        scene.objects = [];
    };


    //----------------------------- Falling item ----------------------------
    // Base settings:
    // image_path - path to falling image
    // start_x, start_y: item position on canvas after adding to scene
    // speed_x, speed_y: linear speed of items on canvas
    // rotate_speed: linear rotate speed

    // Pendulum settings:
    // start_period, period, amplitude, length: phosical values of pendulum oscillations

    // z_index - for layaring, now is not using

    var Item = function (start_x, start_y, rotate_speed, image_path, speed_x, speed_y, start_period,
        amplitude, period, length, z_index) {

        // normalize speed values
        speed_x /= 100;
        speed_y /= 100;
        rotate_speed /= 100;
        //

        var item_scope = this;

        this.x = start_x;
        this.y = start_y;
        this.dx = 0;
        this.dy = 0;

        this.image = get_image(image_path);
        this.angle = Math.random() * 360; //current rotation angle

        this.z_index = z_index;

        // draw item on canvas
        this.draw = function (ctx) {

            var pivot_x = this.x + this.dx + 0.5 * this.image.width,
                pivot_y = this.y + this.dy + 0.5 * this.image.height;

            ctx.save();

            // rotate image with the Canvas API
            ctx.translate(pivot_x, pivot_y);
            ctx.rotate(inRad(this.angle));
            ctx.translate(-pivot_x, -pivot_y);

            // fix a bad images and replace with other from inputted set
            try {

                ctx.drawImage(this.image, this.x + this.dx, this.y + this.dy); // draw image
            }
            catch (ex) {
                console.log("Animation of Fall Exception: Error on draw image '" +
                    image_path + "'\n\rException name: " + ex.name + ", message: " + ex.message);

                replace_bad_image();
            }
            finally {
                ctx.restore();
            }
        };

        // moving item at time
        this.move = function () {

            move_x();
            move_y();

            rotate();
        };

        // ----------------------------- PRIVATE SECTION --------------------------------

        var time_start = new Date(); // value in ticks

        // create DOM image with inputted image path
        function get_image(path) {

            var img = new Image();
            img.src = path;
            return img;
        };

        // remove bad image from input set & replace to random
        function replace_bad_image() {

            var indx = scope.p.item_images.indexOf(image_path);
            if (indx > -1) {

                scope.p.item_images.splice(indx, 1);
                console.log("Image '" + image_path + "' was removed from images set!");

            }
            var new_img = get_random_image(scope.p.item_images);
            item_scope.image = get_image(new_img);
            console.log("Using '" + new_img + "'");
        }

        // inrebent the current rotation angle of the item
        function rotate() {

            item_scope.angle += rotate_speed;
        };

        // move by x and calc DX of pendulum oslillations
        function move_x() {

            check_x();

            item_scope.x += speed_x;

            if (!scope.p.use_pendulum) return; // if pendulum moving is disabled

            var dt = new Date() - time_start;
            // pendulum oscillation by X
            item_scope.dx = Math.cos(start_period + dt /
                (period * 1000.0) * 2 * Math.PI) * amplitude;
        };

        // move by y and calc DY of pendulum oslillations
        function move_y() {

            check_y();
            item_scope.y += speed_y;

            if (!scope.p.use_pendulum) return; // if pendulum moving is disabled

            // pendulum oscillation by Y
            item_scope.dy = -Math.sqrt(length * length + item_scope.dx * item_scope.dx);
        };

        // Check if item is moving at behind of canvas borders by X
        function check_x() {

            //when leaf moved from scene by right
            if (item_scope.x + item_scope.dx - amplitude > canvas.width) {

                item_scope.x = -item_scope.image.width;
                return;
            }

            //when leaf moved from scene by left
            if (item_scope.x + item_scope.dx + amplitude < -item_scope.image.width) {

                item_scope.x = canvas.width;
            }
        };

        // Check if item is moving at behind of canvas borders by Y
        function check_y() {

            //when leaf moved from scene by bottom
            if (item_scope.y + item_scope.dy > canvas.height) {

                item_scope.y = -item_scope.image.height;
            }
        };
    };


    // ------------------ OBKECT DRAWER ------------------------
    var Objects_drawer = function () {

        var scope = this;
        this.ctx = canvas.getContext("2d");

        // draw objects. Objects need to contains a "draw()"
        // and optional "move()" methods
        this.draw_all = function (objects) {

            for (var i = 0; i < objects.length; ++i) {

                objects[i].draw(scope.ctx);
                if (objects[i].move) {
                    objects[i].move();
                }
            }
        };

        // clear canvas
        this.clear_scene = function () {

            scope.ctx.clearRect(0, 0, canvas.width, canvas.height);
        };

        // resize canvas when the dom element was resized
        function on_resize_canvas() {

            canvas.width = canvas.clientWidth;
            canvas.height = canvas.clientHeight;
        }

        window.addEventListener("resize", function () {

            on_resize_canvas();
        });

        on_resize_canvas();
    };


    //----------------------- SCENE --------------------------
    // contains all objects, manage the animation cicle
    // and instance of Objects_drawer
    var Scene = function () {

        var scene_scope = this;
        this.objects = [];
        var objects_drawer = new Objects_drawer();

        this.is_stoped = false;

        // stop animation. break of requestAnimationFrame
        this.stop_ = function () {

            this.is_stoped = true;
        };

        // start animation
        this.start = function () {

            this.is_stoped = false;
            animate();
        };

        // cicle of render the scene
        var animate = function () {

            if (scene_scope.is_stoped) return;

            // not try support all browsers becose support
            // of requestAnimationFrame is equal to canvas support
            requestAnimationFrame(animate);
            update();
        };

        // update all data which depends of time
        var update = function () {

            // break when DOM canvas is not visible on page
            if (!canvas.isVisible()) return;

            objects_drawer.clear_scene();
            objects_drawer.draw_all(scene_scope.objects);
        };

        // sort all objects on the Scene by Z index
        this.sort_objects_by_z_index = function () {

            scene_scope.objects.sort(function (a, b) {

                if (a.z_index == b.z_index) return 0;
                return a.z_index > b.z_index ? 1 : -1;
            });
        };

        // event listiner for canvas resizing
        function on_canvas_resize() {

            // Change items count if used "adaptive_count"
            if (scope.p.adaptive_count) {

                make_proportinal_item_count();
            }
        };

        // Change items count
        function make_proportinal_item_count() {

            var delta = scene_scope.objects.length - Math.round(canvas.width * item_per_width);

            // delete or add 'delta' count of items by randomly
            delta > 0 ?
                delete_randoms(scene_scope.objects, delta) :
                add_new_items(scene_scope.objects, delta * -1);
        }

        // remove random item from scene
        function delete_randoms(array, count) {

            for (var i = 0; i < count; ++i) {

                var r_num = Math.round(Math.random() * array.length);
                array.splice(r_num, 1);
            }
        }

        // add new items to scene
        function add_new_items(array, count) {

            for (var i = 0; i < count; ++i) {

                array.push(create_item());
            }
        }

        window.addEventListener('resize', on_canvas_resize);

        canvas.isVisible = is_visible; // attach 'is_visible' function to DOM element
    };

};

/* eslint-enable */

initialise();

function initialise() {
  const paramCollection = window.fallingLeavesParams || [];

  if (!paramCollection.length) {
    return;
  }

  for (let i = 0; i < paramCollection.length; i += 1) {
    const currentParamSet = paramCollection[i];
    const currentElement = document.getElementById(currentParamSet.canvas_id);

    currentElement.animation_of_fall = new AnimationOfFall(currentElement);
    currentElement.animation_of_fall.init(currentParamSet);
    currentElement.animation_of_fall.play();
  }
}
